import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ActiveTenantService } from './active-tenant.service';
import { TenantSwitcherModalComponent } from '../components/tenant-switcher-modal/tenant-switcher-modal.component';

/**
 * Opens the platform-admin "act as tenant" modal. Extracted out of UserMenuComponent
 * once the side-menu's tenant identity block became a second caller — both open the
 * exact same modal/flow, so the open+handle-result logic lives here once.
 */
@Injectable({ providedIn: 'root' })
export class TenantSwitcherService {
  constructor(
    private readonly modalCtrl: ModalController,
    private readonly activeTenant: ActiveTenantService,
  ) {}

  /** Presents the switcher; on selection, persists it and reloads so every
   *  tenant-scoped view (starting with /auth/me) re-fetches in the new context. */
  async open(): Promise<void> {
    const modal = await this.modalCtrl.create({
      component: TenantSwitcherModalComponent,
      componentProps: { activeId: this.activeTenant.activeId },
      cssClass: 'portal-modal portal-modal-md tenant-switcher-modal',
    });
    await modal.present();
    const { data, role } = await modal.onWillDismiss();
    if (role === 'select' && data) {
      this.activeTenant.set(data);
      window.location.assign('/home');
    }
  }
}
